import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faTiktok,
} from '@fortawesome/free-brands-svg-icons';
import { useNavigate } from 'react-router-dom';
import LazyImage from "./LazyImage";


const logo = `${process.env.PUBLIC_URL}/images/imagess.jpg`;

const Footer = () => {
  const navigate = useNavigate();

  const resorts = {
    india: [
      { name: 'Aanandakosha Ayurveda', id: '/india/aanandakosha' },
      { name: 'Atmaneem Nature Cure', id: '/india/atmaneem' },
      { name: 'Kairali Ayurveda', id: '/india/kairali' },
      { name: 'Mekosha Ayurveda', id: '/india/mekosha-ayurveda' },
      { name: 'Pema Wellness', id: '/india/pema-wellness' },
      { name: 'The TravanCore Heritage', id: '/india/the-travan-core-heritage' },
      { name: 'Veda5', id: '/india/veda-five' },
    ],
    vietnam: [
      { name: 'Avana Retreat', id: '/vietnam/avana-retreat' },
      { name: 'Bamboo Village', id: '/vietnam/bamboo-village' },
      { name: 'Bliss Hoi An', id: '/vietnam/blisshoian' },
      { name: 'Naman Retreat', id: '/vietnam/naman-retreat' },
    ],
    indonesia: [
      { name: 'Desa Seni', id: '/indonesia/desaseni' },
      { name: 'Fivelements Retreat Bali', id: '/indonesia/five-elements-retreat-bali' },
      { name: 'Soulshine Bali', id: '/indonesia/souls-hine-bali' },
      { name: 'SumberKimaHill', id: '/indonesia/sumber-kima-hill' },
      { name: 'The Place Retreats', id: '/indonesia/the-place-retreat' },
    ],
    thailand: [
      { name: 'Aleenta Resorts', id: '/thailand/aleenta-phuket' },
      { name: 'Stay Wellbeing And Lifestyle Resort', id: '/thailand/stay-wellbeing-and-lifestyle-resort' },
    ],
  };

  const handleResortClick = (resortId) => {
    navigate(resortId);
  };

  return (
    <footer className='footer'>
      <div  className='footerContainer'>
        <div className='linksSection'>
          <div className='linkColumnw'>
          <h2 className='footerTitle'>Connect With Us</h2>
          <div className='logoContainer'>
          {/* <img src={logo} alt="Company Logo" className='logo'/> */}
          <LazyImage src={logo} alt="Company Logo" className='logo' />
          </div>
        </div>
        <div className='resortRow'>
         
          <div className='linkColumn'>
            <h3 className='columnTitle'>Wellness Destinations</h3>
              <div className='resortRow'>
                {Object.entries(resorts).map(([country, resortList]) => (
                  <div key={country} className='resortColumn'>
                    <h4  className='countryName'>{country.charAt(0).toUpperCase() + country.slice(1)}</h4>
                    {resortList.map((resort) => (
                      <a
                        key={resort.id}
                        onClick={() => handleResortClick(resort.id)}
                        href="#"
                        className='resortItem'
                      >
                        {resort.name}
                      </a>
                    ))}
                  </div>
                ))}
              </div>
          </div>
          <div className='linkColumn'>
            <h3 className='columnTitle-r'>Resources</h3>
            <div className='linkColumn'>
                {/* <h4 style={styles.countryName}>Wellness: Decoded</h4> */}
                <a href="/glossary" className='link'>Wellness: Decoded</a>
                {/* <h4 style={styles.countryName}>Wellness: Journal</h4> */}
                <a href="/blog" className='link'>Wellness: Journal</a>
                 {/* <h4 style={styles.countryName}>Wellness: Unfolded</h4> */}
                <a href="/gallery" className='link'>Wellness: Unfolded</a>
                 {/* <h4 style={styles.countryName}>Contact</h4> */}
                <a href="/contact" className='link'>Contact</a>
            </div>
          </div>
          <div className='linkColumn'>
            <h3 className='columnTitle-r' >Quick Links</h3>
            <div className='linkColumn'>
                {/* <h4 style={styles.countryName}>About Us</h4> */}
                <a href="/about-us"  className='link'>About Us</a>
                {/* <h4 style={styles.countryName}>Terms & Conditions</h4> */}
                <a href="/terms-conditions"  className='link'>Terms & Conditions</a>
                {/* <h4 style={styles.countryName}>FAQ</h4> */}
                <a href="/privacy-policy"  className='link'>Privacy Policy</a> 
            </div>
          </div>
        </div>
        
        <div className='socialIcons'>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"  className='iconLink'>
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"  className='iconLink'>
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a 
              href="https://instagram.com/wellnessplushealth4all" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="iconLink"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a 
              href="https://www.tiktok.com/@wellnessplushealth4all" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="iconLink"
            >
              <FontAwesomeIcon icon={faTiktok} />
            </a>

        </div>
        </div>
      </div>

      <div className='footerBottom'>
        <p className='footerText'>
          &copy; 2025 Wellness Plus Health 4 All. All Rights Reserved.
        </p>
      </div>
      
      <style>{`
        .resortRow {
          display: flex;
          flex-direction: row;
          gap: 30px;
          margin-top: 10px;
        }
        .resortColumn {
          display: flex;
          flex-direction: column;
          min-width: 180px;
        }
        h3.columnTitle-r {
            margin-bottom: 29px;
            font-size: 18px;
            color: #F76C0D;
           padding-bottom: 20px;
        }
        .countryName {
          font-size: 16px;
          font-weight: bold;
          color: #F76C0D;
          margin-bottom: 8px;
        }

          .footer {
            background-color: #0A3D62;
            color: white;
            padding: 40px 20px;
            position: relative;
            overflow: hidden;
            transition: background-color 0.3s;
            font-family: Laila sans-serif;
            z-index: 2;
          }
          .footerContainer {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            max-width: 1280px;
            margin: 0 auto;
            justify-content: space-between;
            flex-wrap: wrap;
          }
          .linksContainer {
            display: flex;
            flex-direction: column;
            margin-right: 20px;
            flex: 2;
          }
          .logoContainer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-left: auto;
            margin-top: 20px;
            flex: 1,
          }
          .logo {
            max-width: 150px;
            transition: transform 0.3s;
          }
          .footerTitle {
            font-size: 24px;
            margin-bottom: 20px;
            font-family: Laila; sans-serif;
            color: #F76C0D;
          }
          .linkColumnw {
          display: flex;
          }
          .linkColumns {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin-bottom: 20px;
            gap: 20px;
          }
          .linkColumn {
            display: flex;
            flex-direction: column;
            min-width: 150px;
          }
          .columnTitle {
            font-size: 18px;
            margin: 10px 0;
            color: #F76C0D;
          }
          .link {
            margin: 5px 0;
            font-size: 16px;
            color: #E8F8F5;
            text-decoration: none;
            transition: color 0.3s;
            padding: 6px;
          }
          .resortColumns {
            margin-bottom: 10px;
          }
          .resortItem {
            font-size: 16px;
            color: #E8F8F5;
            margin: 5px 0;
            transition: transform 0.3s;
            cursor: pointer;
            text-decoration: none;
            padding-bottom: 20px;
          }
          .socialIcons {
            margin-top: 10px;
            display: flex;
            left: 75%;
            position: relative;
            padding-bottom: 20px;
            margin-top: -67px;
          }
           .iconLink {
            color: #E8F8F5;
            margin: 0 10px;
            transition: transform 0.3s;
            font-size: 2.5rem;
          }
          .icon {
            font-size: 30px;
            transition: transform 0.3s;
          }
          .footerBottom {
            margin-yop: 20px;
            border-top: 1px solid #F76C0D;
            padding-top: 10px;
            text-align: center;
          }
          .footer-text {
            color: '#E8F8F5;
          }
          @media (max-width: 620px) {
            .linkColumnw {
              display: inline-block;
            }
            .logo {
              max-width: 350px;
              transition: transform 0.3s;
            }
          }

        @media (max-width: 992px) {
          .linkColumnw {
              display: inline-block;
          }
        .linksSection .resortRow {
          display: inline-block;
          flex-direction: row;
          gap: 30px;
          margin-top: 10px;
        }
        .resortColumn {
          display: flex;
          flex-direction: column;
          min-width: 180px;
        }

        .countryName {
          font-size: 16px;
          font-weight: bold;
          color: #F76C0D;
          margin-bottom: 8px;
        }

        .footer {
          background-color: #0A3D62;
          color: white;
          padding: 40px 20px;
          position: relative;
          overflow: hidden;
          transition: background-color 0.3s;
          font-family: Laila sans-serif;
          z-index: 2;
        }
          .footerContainer {
            display: inline-block;
            flex-direction: row;
            align-items: flex-start;
            max-width: 1280px;
            margin: 0 auto;
            justify-content: space-between;
            flex-wrap: wrap;
          }
          .linksContainer {
            display: inline-block;
            flex-direction: column;
            margin-right: 20px;
            flex: 2;
          }
          .logoContainer {
           display: inline-block;
            align-items: center;
            justify-content: flex-end;
            margin-left: auto;
            margin-top: 20px;
            flex: 1,
          }
          .logo {
            max-width: 350px;
            transition: transform 0.3s;
          }
          .footerTitle {
            font-size: 24px;
            margin-bottom: 20px;
            font-family: Laila; sans-serif;
            color: #F76C0D;
          }
          
          .linkColumns {
           display: inline-block;
            flex-wrap: wrap;
            width: 100%;
            margin-bottom: 20px;
            gap: 20px;
          }
          .linkColumn {
            display: flex;
            flex-direction: column;
            min-width: 150px;
          }
          .columnTitle {
            font-size: 18px;
            margin: 10px 0;
            color: #F76C0D;
          }
          .link {
            margin: 5px 0;
            font-size: 16px;
            color: #E8F8F5;
            text-decoration: none;
            transition: color 0.3s;
          }
          .resortColumns {
            margin-bottom: 10px;
          }
          .resortItem {
            font-size: 16px;
            color: #E8F8F5;
            margin: 5px 0;
            transition: transform 0.3s;
            cursor: pointer;
            text-decoration: none;
          }
          .socialIcons {
            margin-top: 10px;
            display: block;
          }
          .iconLink {
            color: #E8F8F5;
            margin: 0 10px;
            transition: transform 0.3s;
            font-size: 2.5rem;
          }
          .socialIcons {
              left: 75%;
              position: absolute;
              padding-bottom: 20px;
              margin-top: -194px;
          }
          .icon {
            font-size: 30px;
            transition: transform 0.3s;
          }
          .footerBottom {
            margin-yop: 20px;
            border-top: 1px solid #F76C0D;
            padding-top: 10px;
            text-align: center;
          }
          .footer-text {
            color: '#E8F8F5;
          }
          }
      `}</style>
    </footer>
  );
};

// Updated resorts array with clickable links
// const resorts = [
//   { name: "Vedafive", link: "//india/veda-five" },
//   { name: "Atmaneem", link: "//india/atmaneem" },
//   { name: "Travancore Heritage", link: "//india/the-travan-core-heritage" },
//   { name: "Mekosha Ayurveda", link: "//india/mekosha-ayurveda" },
//   { name: "Wellness Mahotsav", link: "//india/wellness-mahotsav" },
//   { name: "Kairali", link: "//india/kairali" },
//   { name: "Deshadan", link: "//india/deshadan" },
//   { name: "Pema Wellness", link: "//india/pema-wellness" },
//   { name: "Naman Retreat", link: "//vietnam/naman-retreat" },
//   { name: "Avana Retreat", link: "//vietnam/avana-retreat" },
//   { name: "Fiveelements Retreat Bali", link: "//indonesia/five-elements-retreat-bali" },
//   { name: "Casabay Luxury Pool Villas", link: "//thailand/casabay-luxury-pool-villas" },
//   { name: "Stay Wellbeing and Lifestyle Resort", link: "//thailand/stay-wellbeing-and-lifestyle-resort" }
// ];

// const styles = {
  
//   footer: {
//     backgroundColor: '#0A3D62', // Navy blue
//     color: 'white',
//     padding: '40px 20px',
//     position: 'relative',
//     overflow: 'hidden',
//     transition: 'background-color 0.3s',
//     fontFamily: "'Laila', sans-serif", // Apply Laila font
//   },
//   footerContainer: {
//     display: 'flex',
//     flexDirection: 'row', 
//     alignItems: 'flex-start',
//     maxWidth: '1200px',
//     margin: '0 auto',
//     justifyContent: 'space-between', // Space between elements
//   },
//   logoContainer: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'flex-end', 
//     marginLeft: 'auto', 
//     marginTop: '20px',
//   },
//   logo: {
//     maxWidth: '150px', 
//     transition: 'transform 0.3s',
//   },
//   footerTitle: {
//     fontSize: '24px',
//     marginBottom: '20px',
//     fontFamily: "'Laila', sans-serif", // Ensure using Laila for title
//     color: '#F76C0D', // Orange
//   },
//   linksContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'flex-start', 
//     marginRight: '20px',
//   },
//   linkColumns: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     width: '100%', 
//     marginBottom: '20px',
//   },
//   linkColumn: {
//     display: 'flex',
//     flexDirection: 'column',
//     marginRight: '20px',
//     padding: '0 10px', // Add padding to columns for space between items
//   },
//   columnTitle: {
//     fontSize: '20px',
//     margin: '10px 0', // Added margin for spacing
//     color: '#F76C0D', // Orange
//   },
//   link: {
//     margin: '5px 0', 
//     fontSize: '16px',
//     color: '#E8F8F5', // Light green
//     textDecoration: 'none',
//     transition: 'color 0.3s',
//   },
//   resortColumns: {
//     display: 'flex',
//     flexDirection: 'column', // Each column will stack vertically
//     marginBottom: '10px', // Space between items within columns
//   },
//   resortItem: {
//     fontSize: '16px',
//     color: '#E8F8F5',
//     margin: '5px 0',
//     transition: 'transform 0.3s',
//     cursor: 'pointer', // Change cursor to pointer
//     padding: '5px 0', // Padding for better spacing around items
//     textDecoration: 'none', // Remove underline for links
//   },
//   socialIcons: {
//     marginTop: '10px',
//     display: 'flex', 
//   },
//   iconLink: {
//     color: '#E8F8F5', // Light green
//     margin: '0 10px',
//     transition: 'transform 0.3s',
//   },
//   icon: {
//     fontSize: '30px',
//     transition: 'transform 0.3s',
//   },
//   footerBottom: {
//     marginTop: '20px',
//     borderTop: '1px solid #F76C0D', // Orange
//     paddingTop: '10px',
//     textAlign: 'center',
//   },
//   footerText: {
//     color: '#E8F8F5', // Light green
//   },
// };


// const styles = {
// //   resortRow: {
// //   display: 'flex',
// //   flexDirection: 'row',
// //   // flexWrap: 'wrap',
// //   gap: '30px',
// //   marginTop: '10px',
// // },

// // resortColumn: {
// //   display: 'flex',
// //   flexDirection: 'column',
// //   minWidth: '180px',
// // },

// // countryName: {
// //   fontSize: '16px',
// //   fontWeight: 'bold',
// //   color: '#F76C0D',
// //   marginBottom: '8px',
// // },

// //   footer: {
// //     backgroundColor: '#0A3D62',
// //     color: 'white',
// //     padding: '40px 20px',
// //     position: 'relative',
// //     overflow: 'hidden',
// //     transition: 'background-color 0.3s',
// //     fontFamily: "'Laila', sans-serif",
// //     zIndex: "2",
// //   },
// //   footerContainer: {
// //     display: 'flex',
// //     flexDirection: 'row',
// //     alignItems: 'flex-start',
// //     maxWidth: '1280px',
// //     margin: '0 auto',
// //     justifyContent: 'space-between',
// //     flexWrap: 'wrap',
// //   },
// //   linksContainer: {
// //     display: 'flex',
// //     flexDirection: 'column',
// //     marginRight: '20px',
// //     flex: 2,
// //   },
// //   logoContainer: {
// //     display: 'flex',
// //     alignItems: 'center',
// //     justifyContent: 'flex-end',
// //     marginLeft: 'auto',
// //     marginTop: '20px',
// //     flex: 1,
// //   },
// //   logo: {
// //     maxWidth: '150px',
// //     transition: 'transform 0.3s',
// //   },
// //   footerTitle: {
// //     fontSize: '24px',
// //     marginBottom: '20px',
// //     fontFamily: "'Laila', sans-serif",
// //     color: '#F76C0D',
// //   },
// //   linkColumnw: {
// //   display: 'flex',
// //   },
// //   linkColumns: {
// //     display: 'flex',
// //     flexWrap: 'wrap',
// //     width: '100%',
// //     marginBottom: '20px',
// //     gap: '20px',
// //   },
// //   linkColumn: {
// //     display: 'flex',
// //     flexDirection: 'column',
// //     minWidth: '150px',
// //   },
// //   columnTitle: {
// //     fontSize: '18px',
// //     margin: '10px 0',
// //     color: '#F76C0D',
// //   },
// //   link: {
// //     margin: '5px 0',
// //     fontSize: '16px',
// //     color: '#E8F8F5',
// //     textDecoration: 'none',
// //     transition: 'color 0.3s',
// //   },
// //   resortColumns: {
// //     marginBottom: '10px',
// //   },
// //   resortItem: {
// //     fontSize: '16px',
// //     color: '#E8F8F5',
// //     margin: '5px 0',
// //     transition: 'transform 0.3s',
// //     cursor: 'pointer',
// //     textDecoration: 'none',
// //   },
// //   socialIcons: {
// //     marginTop: '10px',
// //     display: 'flex',
// //   },
// //   iconLink: {
// //     color: '#E8F8F5',
// //     margin: '0 10px',
// //     transition: 'transform 0.3s',
// //   },
// //   icon: {
// //     fontSize: '30px',
// //     transition: 'transform 0.3s',
// //   },
// //   footerBottom: {
// //     marginTop: '20px',
// //     borderTop: '1px solid #F76C0D',
// //     paddingTop: '10px',
// //     textAlign: 'center',
// //   },
// //   footerText: {
// //     color: '#E8F8F5',
// //   },
// };

export default Footer;